// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2A-ud","obliqueLineWrap":"membershipbadge_obliqueLineWrap__tvEaI","obliqueLine":"membershipbadge_obliqueLine__1Jh9V"};